import React, { Component } from 'react';
import { Form, FormGroup, FormControl, ControlLabel, Col, Button } from 'react-bootstrap';
import Api from '../../../../../Global/Modules/Api'
import { Link } from 'react-router-dom';
import { getYearOptions } from '../../../services/dateServices';
const FETCH_URL = "api/educations/membershipadmin"
class ComissielidAdd extends Component {

    constructor() {
        super();
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.state = {
            errors: {},
            visible: false,
            required: false
        }
    }
    handleChange(event) {
        const target = event.target
        const name = target.name
        const value = target.value
        if (value == "Overig" && name == "name") {
            this.setState({ visible: true });
        } else {
            if (value != "Overig" && name == "name") {
                this.setState({ visible: false });
            }
        }
        if ((value != "" && value != undefined) && name == "description") {
            this.setState({ required: false });
        }
    }
    // Function that will be executed when the submit button is pressed
    handleSubmit(event) {
        event.preventDefault()

        var payload = {}
        const formData = event.target.elements
        for (var i = 0; i < formData.length; i++) {
            const e = formData[i] // Form element
            const name = e.name
            const value = e.value

            if (name && value)
                payload[name] = value
        }
        if (payload['name'] == "Overig" && (payload['description'] == "" || payload['description'] == undefined)) {
            this.setState({ required: true });
            return false;
        }
        payload['type'] = 'committe'
        payload['MemberId'] = this.props.id
        // TODO: Post payload to the API
        Api.PostApi(FETCH_URL, payload, this.props.history)
            .then(response => {
                alert("Comissielid added")
                window.location.href = '/admin/leden/lid/kennis/' + this.props.id


            })

    }

    render() {
        let errors = this.state.errors
        return (
            <Form horizontal onSubmit={this.handleSubmit}>
                <FormGroup controlId="ComissielidTypeVereniging">
                    <Col componentClass={ControlLabel} sm={4}>
                        Naam commissie
                    </Col>
                    <Col sm={6}>
                        <FormControl name="name" componentClass="select" onChange={this.handleChange}>
                            <option value="">Selecteer</option>
                            <option value="COBc">COBc</option>
                            <option value="CUR">CUR</option>
                            <option value="CURNET">CURNET</option>
                            <option value="ECCS">ECCS</option>
                            <option value="IABSE">IABSE</option>
                            <option value="NEN">NEN</option>
                            <option value="SBR">SBR</option>
                            <option value="Stubeco">Stubeco</option>
                            <option value="Stufib">Stufib</option>
                            <option value="Stumico">Stumico</option>
                            <option value="Stutech">Stutech</option>
                            <option value="TC Bouwen met Staal">TC Bouwen met Staal</option>
                            <option value="Overig">Overig</option>
                        </FormControl>
                    </Col>
                </FormGroup>
                <FormGroup controlId="ComissielidToelichting" style={{ display: this.state.visible ? 'block' : 'none' }}>
                    <Col componentClass={ControlLabel} sm={4}>
                        Naam commissie *
                    </Col>
                    <Col sm={6}>
                        <FormControl name="description" type="text" style={{ border: this.state.required ? '1px solid red' : 'none' }} />
                        {/* {Api.showError(errors, "activities")} */}
                    </Col>
                </FormGroup>
                <FormGroup controlId="RedactielidVan">
                    <Col componentClass={ControlLabel} sm={4}>
                        Van
                    </Col>

                    <Col sm={6}>
                        <FormControl name="yearInit" componentClass="select" required>
                            <option value="">selecteer</option>
                            {getYearOptions()}
                        </FormControl>
                        {Api.showError(errors, "from")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="RedactielidTot">
                    <Col componentClass={ControlLabel} sm={4}>
                        T/m
                    </Col>

                    <Col sm={6}>
                        <FormControl name="yearEnd" componentClass="select" required>
                            <option value="">selecteer</option>
                            {getYearOptions()}
                        </FormControl>
                        {Api.showError(errors, "to")}
                    </Col>
                </FormGroup>

                <FormGroup>
                    <Col sm={2}>
                        <Link to={'/admin/leden/lid/kennis/' + this.props.id} className="btn btn-default">Terug</Link>
                    </Col>
                    <Col smOffset={8} sm={2}>
                        <Button type="submit">Voeg Toe</Button>
                    </Col>
                </FormGroup>
            </Form>
        );
    }
}

export default ComissielidAdd;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Leden/Lid/Toevoegen/ComissielidAdd.js